export default __webpack_public_path__ + "static/media/meat.94763ef2.png";